import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2700To2799Service {

  constructor() { }
}
